"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
/**
 * Handle datamints_feuser forms
 *
 * @namespace
 * @memberOf txGs1Base.forms
 * @public
 */
const _main_1 = require("../_main");
_main_1.txGs1Base.forms.datamintsFeuser = {
    /**
     * Initialize class and markup replacement
     */
    initialize: function () {
        var $datamintsFormWrapperElement = $('.tx-datamintsfeuser-pi1');
        if ($datamintsFormWrapperElement.length > 0) {
            $datamintsFormWrapperElement.find('fieldset').wrap('<div class="content-module-container"><div class="content-module-wrapper"><div class="content-module content-module-padding"></div></div></div>');
            $datamintsFormWrapperElement.find('form').attr('role', 'form');
            $datamintsFormWrapperElement.find('fieldset > div').addClass('form-group');
            $datamintsFormWrapperElement.find('.item:odd').addClass('odd');
            $datamintsFormWrapperElement.find('.item:even').addClass('even');
            $datamintsFormWrapperElement.find('.type-input input').addClass('form-control');
            $datamintsFormWrapperElement.find('.type-radio, .type-check, .type-userdelete').addClass('form-group');
            $datamintsFormWrapperElement.find('.type-check').wrapInner('<div class="checkbox"></div>');
            var $checkOrRadioLabels = $datamintsFormWrapperElement.find('.type-radio > label, .type-check > label');
            $checkOrRadioLabels.each(function () {
                if ($(this).next('.list').length > 0) {
                    $(this).replaceWith('<legend class="label-alike">' + $(this).html() + '</legend>');
                }
                else {
                    $(this).insertAfter($(this).parent().find('input[type="checkbox"]'));
                }
            });
            var $listElements = $datamintsFormWrapperElement.find('.list > div');
            $listElements.unwrap().addClass('radio');
            $listElements.find('[type="radio"]').each(function (i, item) {
                var $next = $(item).next();
                if ($next.is('label') === true) {
                    $(item).prependTo($next);
                }
            });
            var $submitButton = $datamintsFormWrapperElement.find('.name-submit input');
            $submitButton.replaceWith('<button class="btn-margin btn-primary" value="' + $submitButton.attr('value') + '">' + $submitButton.attr('value') + '</button>');
            $datamintsFormWrapperElement.find('.error-label')
                .addClass('error-msg')
                .closest('.item').addClass('has-error has-feedback')
                .append('<span class="icon-close form-control-feedback"></span>');
        }
    }
};
exports.default = {};
